<template lang="pug">
  validation-observer(ref='observer' tag='form')
    div.container-cadastro
      div#passos
        el-steps(:active="passoAtivo" finish-status="success" simple)
          el-step(title="Informar dados do Ofício de Matrícula")
          el-step(title="Confirmar Ofício de Matrícula")
      div#corpo
        informar-dados(
          v-if="passoAtivo === 0"
          :oficio="oficio"
          )
        confirmar-matricula(
          v-if="passoAtivo === 1"
          :oficio="oficio"
          @getBytesPdf="getBytesPdf"
        )

      app-buttons-cadastro(
        :isPrimeiroPasso="false",
        :isUltimoPasso="ultimoPasso",
        :showButtonProximo="!ultimoPasso"
        :showButtonCancelar="false",
        :showButtonSalvar="passoAtivo === 0",
        :showButtonDownload="passoAtivo !== 0"
        @proximo="proximo",
        @finalizar="finalizar",
        @salvar="salvar",
        @voltar="voltar",
        @download="download"
      )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformarDados from '@/screens/arrecadacao/gp/components/matricula/InformarDadosMatricula'
import ConfirmarMatricula from '@/screens/arrecadacao/cpat/components/matricula/ConfirmarMatricula'
import FileHelper from '@/utils/fileHelper'
import { mapActions } from 'vuex'

export default {
  components: {
    InformarDados,
    ConfirmarMatricula,
    AppButtonsCadastro
  },

  mixins: [AppNotificacao],

  data () {
    return {
      passoAtivo: 0,
      bytes: [],
      acao: null
    }
  },

  props: {
    oficio: {
      type: Object,
      required: true
    }
  },

  computed: {
    ultimoPasso () {
      return this.passoAtivo === 1
    }
  },

  methods: {
    ...mapActions({
      salvarPasso: 'portariaArrecadacao/atualizarDiarioOficial',
      getPDFMatricula: 'oficioArrecadacao/getPDFMatricula',
      finalizarMatricula: 'processoArrecadacao/tramitarComAcao',
      tarefa: 'processoArrecadacao/tarefa'
    }),

    getBytesPdf (bytes) {
      this.bytes = bytes
    },

    async salvar () {
      const valido = await this.validarCampos()
      if (valido) {
        const dados = {
          portariaId: this.oficio.processo.portaria.id,
          dataPublicacao: this.oficio.processo.portaria.dataPublicacao,
          numeroEdicaoPublicacao: this.oficio.processo.portaria
            .numeroEdicaoPublicacao
        }
        try {
          const response = await this.salvarPasso(dados)
          if (response) {
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              this.$messages.DADOS_SALVOS_SUCESSO
            )
          }
        } catch (error) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            error.message
          )
        }
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_EMISSAO_MINUTA
        )
      }
    },

    async proximo () {
      if (this.passoAtivo === 0) {
        const valido = await this.validarCampos()

        if (valido) {
          await this.salvar()
          this.passoAtivo = this.passoAtivo + 1
        } else {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
          )
        }
      } else {
        this.passoAtivo = this.passoAtivo + 1
      }
    },

    finalizar () {
      this.acao = 'AGUARDANDO_ASSINATURA_MATRICULA.PRESIDENTE.GP'
      this.confirmBox(
        'Deseja confirmar esta ação?',
        this.$messages.TITULO_WARNING,
        () => {
          this.finalizarMatricula({
            processoId: this.oficio.processo.id,
            acao: this.acao
          })
            .then(response => {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                response
              )
              this.goToListagem()
            })
            .catch(error => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                error.message
              )
            })
        },
        () => {},
        'Sim',
        'Não'
      )
    },

    download () {
      const nome = 'documentos_dados_minuta_portaria.pdf'
      FileHelper.saveFile(this.bytes, nome)
    },

    voltar () {
      if (this.passoAtivo !== 0) {
        this.passoAtivo = this.passoAtivo - 1
      } else {
        this.confirmBox(
          'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
          this.$messages.TITULO_WARNING,
          () => {
            this.goToListagem()
          },
          () => {},
          'Sim',
          'Não'
        )
      }
    },
    validarCampos () {
      return this.$refs.observer.validate()
    },
    goToListagem () {
      this.$router.push({
        name: 'GP_S1_CAIXA_DE_ENTRADA'
      })
    }
  },
  watch: {
    oficio: {
      async handler () {
        if (this.oficio?.processo?.id) {
          const acao = await this.tarefa({ processo: this.oficio.processo.id })
          this.acao = acao.acoes[0].valor
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/matricula/EmissaoMatricula.vue